import {mapActions, mapGetters} from "vuex";
// import router from '@/router/router'
import {getWincourseTicket} from "@/api/auth/jwt";

/**
 * 携带ticket令牌跳转至云课时间课程详情页
 * @param courseId 云课时间课程id
 * @param ticket ticket令牌
 */
export function handleToCourseDetailPage(courseId, ticket) {
    if (courseId == null || courseId === '') {
        this.$message.warning("云课时间课程信息缺失")
        return
    }
    if (ticket == null || ticket === '') {
        this.$message.warning("云课时间ticket令牌信息缺失")
        return
    }

    // 云课时间前端基础路径
    let webBaseUrl = window._CONFIG['domianWebURL']
    // window.open(`${webBaseUrl}/publicPages/courseDetail/${courseId}?ticket=${ticket}`, "_blank")
    window.open(`${webBaseUrl}/course/${courseId}/check/ticket/${ticket}`, "_blank")
}

const WincourseMixin = {
    computed: {
        ...mapGetters(["token", "userInfo"]),
    },
    methods: {
        ...mapActions(["setLoginVisible"]),
        /**
         * 点击了云课时间公开课
         * @param record 云课时间公开课详情
         */
        wincourseItemOnClick(record) {
            let {courseId} = record
            // 判断用户是否登录
            if (this.token) {
                // 判断是否绑定 云课时间 用户
                let {wincourse} = this.userInfo
                if (!wincourse) {
                    // 未绑定，创建/绑定 云课时间 用户
                    this.$confirm('请绑定“云课时间”账号后查看课程详情', '提示', {
                        confirmButtonText: '绑定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.$router.push({
                                name: "createOrBindWincourseUser",
                                query: {
                                    courseId
                                }
                            })
                        })
                        .catch(() => {
                            // do something
                        });
                } else {
                    this.handleToCourseDetailPage(courseId)
                }
            } else {
                this.setLoginVisible(true);
            }
        },
        getTicket(courseId) {
            return getWincourseTicket(courseId)
        },
        /**
         * 携带ticket令牌跳转至云课时间课程详情页
         */
        handleToCourseDetailPage(courseId) {
            // 获取ticket
            this.getTicket(courseId)
                .then(ticket => {
                    handleToCourseDetailPage(courseId, ticket)
                })
        }
    }
}

export default WincourseMixin
